import { AtomicBlockType as DraftjsAtomicBlockType } from '@uno/common-cms';
import { addAtomicBlock } from '../../util';
export var transformBeopToDraftjsAndAppend = function transformBeopToDraftjsAndAppend(block, rawDraftContentState) {
  return addAtomicBlock(rawDraftContentState, DraftjsAtomicBlockType.BEOP, {
    blockData: {},
    entityData: {}
  });
};